import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Divider,
} from '@material-ui/core';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { errorsSlice } from '../modules/Auth/_redux/errorRedux';
import { useHistory } from 'react-router';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

function HttpErrorDialog({ intl }) {
  const dispatch = useDispatch();
  const state = useSelector(state => state.errors);
  const open = state.error ? true : false;
  const history = useHistory();
  if (state.error.response && state.error.response.status === 401) {
    onClose();
    window.isUnauthorized = true;
    history.push('/logout');
  }
  if (state.error.response && state.error.response.status === 500)
    state.error.response.data = '500';
  if (state.error.response && state.error.response.status === 404) {
    if (state.error.config.method === 'get') {
      onClose();
      history.push('/404');
    } else {
      state.error.response.data = '404';
    }
  }
  if (state.error.response && state.error.response.status === 403)
    state.error.response.data = '403';
  if (state.error.response && state.error.response.status === 409)
    state.error.response.data = '409';
  if (state.error.response && state.error.response.status === 400)
    state.error.response.data = '400';

  function onClose() {
    dispatch(errorsSlice.actions.catchError(false));
  }
  return (
    <Dialog fullWidth open={open}>
      <DialogTitle>
        <div className="col-12">Oops!</div>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ minHeight: 80 }}>
        <div className="d-flex">
          <div className="col-2">
            <SVG src={toAbsoluteUrl('/media/senseworks/alert.svg')} />
          </div>
          <div className="col-10 d-flex align-items-center">
            {state.error.response
              ? intl.formatMessage({
                  id: `E${state.error.response.data?.message ||
                    state.error.response.data}`,
                })
              : null}
          </div>
        </div>
      </DialogContent>
      <Divider />
      <DialogActions>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-bordered h-25px w-50px d-flex align-items-center btn-primary justify-content-center"
        >
          {intl.formatMessage({ id: 'ACTIONS.OK' })}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default injectIntl(HttpErrorDialog);
